// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"StandardTable_toolbar__Uw4nF","operations":"StandardTable_operations__24cK0","toolbarItem":"StandardTable_toolbarItem__2_mXu"};